module.exports = __webpack_public_path__ + "static/media/rock_paper_scissors.fe9161e1.png";